export default __webpack_public_path__ + "static/media/protects-bg.7f7118f2.png";